<template>
  <div class="user-login">
    <b-row class="justify-content-center">
      <b-col sm="6">
        <b-card :header="$t('login.title')">
          <i18n
            path="login.introtext"
            tag="b-card-text"
            for="register.title"
            v-show="!mfaSetupCode && !showMfaConfirmationCodeInput"
          >
            <router-link :to="{name: 'register'}">
              {{ $t('register.title') }}
            </router-link>
          </i18n>
          <b-form
            v-show="!mfaSetupCode && !showMfaConfirmationCodeInput"
            @submit.prevent.prevent="signIn"
          >
            <b-form-group
              label-cols-lg="2"
              :label="$t('login.input.email.label')"
              label-for="input-email"
            >
              <b-form-input
                v-model="username"
                :placeholder="$t('login.input.email.placeholder')"
                type="email"
                id="input-email"
                autocomplete="username"
                :required="true"
              />
            </b-form-group>
            <b-form-group
              label-cols-lg="2"
              :label="$t('login.input.password.label')"
              label-for="input-password"
            >
              <b-form-input
                v-model="password"
                :placeholder="$t('login.input.password.placeholder')"
                type="password"
                id="input-password"
                autocomplete="current-password"
                :required="true"
              />
            </b-form-group>
            <b-button
              type="submit"
              variant="primary"
              block
              :disabled="isLoading"
            >
              <b-spinner
                small
                v-show="isLoading"
              />
              {{ $t('login.submitButtonText') }}
            </b-button>
            <router-link
              class="text-center mt-3 d-block"
              :to="{name: 'forgot-password', query: {email: this.username}}"
            >
              {{ $t('login.forgotPassword') }}
            </router-link>
          </b-form>
          <b-row
            v-if="mfaSetupCode"
            class="justify-content-md-center mt-3"
          >
            <b-col cols="8">
              <mfa-setup
                v-if="mfaSetupCode"
                :username="this.username"
                :secret="this.mfaSetupCode"
                :cognito-user="cognitoUser"
              />
            </b-col>
          </b-row>
          <b-row
            v-if="showMfaConfirmationCodeInput"
            class="justify-content-md-center mt-3"
          >
            <b-col cols="8">
              <b-form @submit.prevent="confirmSignIn">
                <b-form-group
                  label-cols-lg="2"
                  :label="$t('login.input.otp.label')"
                  label-for="input-password"
                >
                  <b-form-input
                    v-model="mfaConfirmationCode"
                    :placeholder="$t('login.input.otp.placeholder')"
                    type="password"
                    id="input-otp"
                    autocomplete="one-time-code"
                    :required="true"
                  />
                </b-form-group>
                <b-button
                  type="submit"
                  variant="primary"
                  block
                >
                  {{ $t('login.submitButtonText') }}
                </b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-card>
        <b-button
          @click="redirectToHostedUI"
          type="submit"
          variant="primary"
          block
        >
          Hosted UI / Federated SignIn
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { Auth } from "aws-amplify";
import MfaSetup from "./MfaSetup.vue";

export default {
  name: "UserLogin",
  components: {
    MfaSetup
  },
  data: function() {
    return {
      username: "",
      password: "",
      mfaSetupCode: "",
      mfaConfirmationCode: "",
      showMfaConfirmationCodeInput: false,
      // @todo: write cognitoUser to Vuex to get access of current user all over the app
      cognitoUser: {},
      loggedInUser: {},
      isLoading: false
    };
  },
  methods: {
    signIn: async function() {
      this.isLoading = true;
      this.$store.commit("unsetAllAlerts", true);
      try {
        const user = await Auth.signIn(this.username, this.password);
        console.log(user);
        this.cognitoUser = user;
        if (
          user.challengeName === "SMS_MFA" ||
          user.challengeName === "SOFTWARE_TOKEN_MFA"
        ) {
          // You need to get the code from the UI inputs
          // and then trigger the following function with a button click
          // const code = getCodeFromUserInput();
          // // If MFA is enabled, sign-in should be confirmed with the confirmation code
          this.showMfaConfirmationCodeInput = true;
          // const loggedUser = await Auth.confirmSignIn(
          //     user,   // Return object from Auth.signIn()
          //     this.mfaConfirmationCode,   // Confirmation code
          //     "SOFTWARE_TOKEN_MFA" // MFA Type e.g. SMS_MFA, SOFTWARE_TOKEN_MFA
          // );
        } else if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          // const {requiredAttributes} = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
          // // You need to get the new password and required attributes from the UI inputs
          // // and then trigger the following function with a button click
          // // For example, the email and phone_number are required attributes
          // const {username, email, phone_number} = getInfoFromUserInput();
          // const loggedUser = await Auth.completeNewPassword(
          //     user,              // the Cognito User Object
          //     newPassword,       // the new password
          //     // OPTIONAL, the required attributes
          //     {
          //         email,
          //         phone_number,
          //     }
          // );
        } else if (user.challengeName === "MFA_SETUP") {
          // This happens when the MFA method is TOTP
          // The user needs to setup the TOTP before using it
          // More info please check the Enabling MFA part
          Auth.setupTOTP(user).then(code => {
            console.log("mfa code:", code);
            this.mfaSetupCode = code;
            // You can directly display the `code` to the user or convert it to a QR code to be scanned.
            // E.g., use following code sample to render a QR code with `qrcode.react` component:
            //      import QRCode from 'qrcode.react';
            //      const str = "otpauth://totp/AWSCognito:"+ username + "?secret=" + code + "&issuer=" + issuer;
            //      <QRCode value={str}/>
          });
        } else {
          // The user directly signs in
          console.log(user);
        }
      } catch (err) {
        this.isLoading = false;
        if ({}.hasOwnProperty.call(err, "message")) {
          this.$store.commit("setAlert", {
            variant: "danger",
            message: err.message
          });
        }
        if (err.code === "UserNotConfirmedException") {
          // The error happens if the user didn't finish the confirmation step when signing up
          // In this case you need to resend the code and confirm the user
          // About how to resend the code and confirm the user, please check the signUp part
          Auth.resendSignUp(this.username)
            .then(() => {
              console.log("code resent successfully");
              this.$store.commit("setAlert", {
                variant: "info",
                message:
                  "We resend you an e-mail with a verification token. Please enter the Token in the form below."
              });
              this.$store.commit("setSignedUp", true);
              this.$router.push({
                name: "register",
                query: {
                  email: this.username
                }
              });
            })
            .catch(e => {
              console.log(e);
            });
        } else if (err.code === "PasswordResetRequiredException") {
          // The error happens when the password is reset in the Cognito console
          // In this case you need to call forgotPassword to reset the password
          // Please check the Forgot Password part.
        } else if (err.code === "NotAuthorizedException") {
          // The error happens when the incorrect password is provided
        } else if (err.code === "UserNotFoundException") {
          // The error happens when the supplied username/email does not exist in the Cognito user pool
        } else {
          console.log(err);
        }
      }
    },
    confirmSignIn: function() {
      console.log("this.cognitoUser:", this.cognitoUser);
      console.log("this.mfaConfirmationCode:", this.mfaConfirmationCode);
      Auth.confirmSignIn(
        this.cognitoUser, // Return object from Auth.signIn()
        this.mfaConfirmationCode, // Confirmation code
        "SOFTWARE_TOKEN_MFA" // MFA Type e.g. SMS_MFA, SOFTWARE_TOKEN_MFA
      )
        .then(data => {
          Auth.signIn(this.username, this.password);
          console.log("data:", data);
        })
        .catch(err => {
          this.$store.commit("setAlert", {
            variant: "danger",
            message: err.message
          });
        });
    },
    getUsernameFromParam: function() {
      if (this.$route.query.email) {
        this.username = this.$route.query.email;
      }
    },
    redirectToHostedUI: function() {
      console.log('click');
      Auth.federatedSignIn();
    },
  },
  mounted() {
    AmplifyEventBus.$on("authState", eventInfo => {
      if (eventInfo === "signedIn") {
        this.$router.push({ name: "home" });
      } else if (eventInfo === "signedOut") {
        this.$router.push({ name: "frontDoor" });
      }
    });
  },
  created() {
    this.getUsernameFromParam();
  }
};
</script>